<aside
  [attr.aria-label]="ariaLabel ? ariaLabel : 'Extra page information'"
  class="callout flex-container flex-dir-row"
  [ngClass]="[
    base ? 'callout--' + base : '',
    type ? 'callout--' + type : '',
    animation ? 'no-animation' : '',
    paddingOrMarginAlteration ? paddingOrMarginAlteration : '',
    positioning ? positioning : '',
    error ? 'callout--' + type + '--error' : ''
  ]"
  data-test="mono-common-callout"
  [attr.id]="type === 'info-text' ? 'ariaInputDescription' : null"
  [attr.role]="animation !== 'no-animation' ? 'alert' : null"
>
  <div *ngIf="!success && !error" class="flex-container width-100">
    <svg class="icon icon--info-circle">
      <use xlink:href="#icon-info-circle" href="#icon-info-circle"></use>
    </svg>
    <p [innerHTML]="calloutText | dontSanitizeHtml" class="align-self-middle"></p>
  </div>
  <div *ngIf="success" class="flex-container align-middle align-center">
    <span>{{ calloutText }}</span>
    <svg class="icon icon--checkmark">
      <use xlink:href="#icon-checkmark" href="#icon-checkmark"></use>
    </svg>
  </div>
  <div *ngIf="error" class="flex-container flex-dir-column">
    <div class="flex-container align-justify">
      <span>{{ calloutText }}</span>
      <svg class="icon icon--warning">
        <use xlink:href="#icon-warning" href="#icon-warning"></use>
      </svg>
    </div>
    <p *ngIf="errorDescription" class="normal-text-weight padding-top-0-5">{{ errorDescription }}</p>
  </div>
  <ng-container *ngIf="calloutButtons">
    <ng-content select="[calloutButtons]"></ng-content>
  </ng-container>
</aside>
